import { render } from "./AcceptInvitation.vue?vue&type=template&id=b6a169c4&scoped=true"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js"

import "./AcceptInvitation.vue?vue&type=style&index=0&id=b6a169c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a169c4"]])

export default __exports__